module.exports = __webpack_public_path__ + "b35da947c161625f19f3d87e52523210.png";